<template>
  <div>
    <MenuPos />
    <!-- <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_poslist">
                <img src="@/assets/restaurant.png">
            </div>
            <h2 class="title_poslist">ระบบ POS</h2>
        </div>

        <v-btn color="success" class="titlefont_poslist d-none d-sm-flex" height="50" width="20%" @click="$router.push('/restaurant')">
            ย้อนกลับ
        </v-btn>
        <v-btn color="success" class="titlefont_poslist d-flex d-sm-none" height="50" @click="$router.push('/restaurant')">
            ย้อนกลับ
        </v-btn>
    </div> -->
    <v-slide-x-reverse-transition>
      <v-alert type="error" class="alert_success" v-if="alert_error_close_shop === true">{{ message_error_close_shop
        }}</v-alert>
      <v-alert type="success" class="alert_success"
        v-if="alert_money_in_out_notify === true">บันทึกเงินเข้าเรียบร้อยแล้ว</v-alert>
      <v-alert type="success" class="alert_success"
        v-if="message_remove_money_in_out === true">ยกเลิกเงินเข้าเรียบร้อยแล้ว</v-alert>
      <v-alert type="success" class="alert_success" v-if="alert_add_num_table === true">เพิ่มโต๊ะเรียบร้อยแล้ว</v-alert>
      <v-alert type="success" class="alert_success"
        v-if="alert_remove_num_table === true">เอาโต๊ะออกเรียบร้อยแล้ว</v-alert>
      <v-alert type="error" class="alert_success" v-if="alert_error_remove_num_table === true">{{
        message_error_remove_num_table }}</v-alert>
      <v-alert type="success" class="alert_success"
        v-if="alert_delivery === true">เพิ่มเดริเวอร์รี่เรียบร้อยแล้ว</v-alert>
      <v-alert type="success" class="alert_success"
        v-if="alert_edit_delivery === true">แก้ไขเดริเวอร์รี่เรียบร้อยแล้ว</v-alert>
      <v-alert type="success" class="alert_success"
        v-if="alert_delete_delivery === true">ลบเดริเวอร์รี่เรียบร้อยแล้ว</v-alert>
      <v-alert type="error" class="alert_success"
        v-if="alert_error_amount_buffet === true">กรุณาใส่จำนวนลูกค้าบุฟเฟ่ต์</v-alert>
      <v-alert type="error" class="alert_success"
        v-if="alert_error_amount_no_buffet === true">กรุณาใส่จำนวนลูกค้าทานที่ร้าน</v-alert>
      <v-alert type="error" class="alert_success" v-if="alert_error_per_table === true">กรุณาเลือกโต๊ะที่จะต่อ</v-alert>
      <v-alert type="success" class="alert_success"
        v-if="alert_edit_table_name_success === true">แก้ไขชื่อโต๊ะเรียบร้อยแล้ว</v-alert>
      <v-alert type="success" class="alert_success"
        v-if="alert_table_takeout_success === true">เอาโต๊ะออกเรียบร้อยแล้ว</v-alert>
      <v-alert type="error" class="alert_success" v-if="alert_error_open_table === true">{{ message_error_open_table
        }}</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card>
        <div class="pa-3">
          <v-row>
            <v-col cols="12">
              <div class="d-none d-sm-flex justify-end mb-2">
                <div class="d-flex align-center mr-1">
                  <div class="mr-1 open_table_pos_list"></div>
                  <div>โต๊ะที่กำลังเปิดอยู่</div>
                </div>
                <div class="d-flex align-center ml-2 mr-2">
                  <div class="mr-1 open_per_table_pos_list"></div>
                  <div>โต๊ะที่กำลังต่อโต๊ะ</div>
                </div>
                <div class="d-flex align-center ml-1">
                  <div class="mr-1 open_on_table_pos_list"></div>
                  <div>โต๊ะที่สามารถใช้งานได้</div>
                </div>
              </div>
              <div class="d-sm-none detail_table_list_pos_list mb-2">
                <div class="d-flex align-center mb-2">
                  <div class="mr-1 open_table_pos_list"></div>
                  <div>โต๊ะที่กำลังเปิดอยู่</div>
                </div>
                <div class="d-flex align-center mb-2">
                  <div class="mr-1 open_per_table_pos_list"></div>
                  <div>โต๊ะที่กำลังต่อโต๊ะ</div>
                </div>
                <div class="d-flex align-center mb-2">
                  <div class="mr-1 open_on_table_pos_list"></div>
                  <div>โต๊ะที่สามารถใช้งานได้</div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" xl="4">
              <v-btn class="mb-3" height="65" width="100%" @click="openMoneyInOut()">
                <div class="d-flex justify-center align-center">
                  <div class="money_in_out_img_poslist">
                    <img src="@/assets/icon-restaurant-mini-income.png">
                  </div>
                  <div class="titlefont_poslist">
                    รับเงินเข้า
                  </div>
                </div>

              </v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" xl="4">
              <v-btn class="mb-3" height="65" width="100%" @click="$router.push('/salereportday')"
                v-if="$store.state.userProfile.per_report_retrospect == 1">
                <div class="d-flex justify-center align-center">
                  <div class="money_in_out_img_poslist">
                    <img src="@/assets/icon-restaurant-mini-chart.png">
                  </div>
                  <div class="titlefont_poslist">
                    รายงานร้านอาหาร
                  </div>
                </div>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" xl="4">
              <v-btn class="mb-3" height="65" width="100%" @click="quickFood_detail()">
                <div class="d-flex justify-center align-center">
                  <div class="money_in_out_img_poslist">
                    <img src="@/assets/icon-restaurant-mini-order.png">
                  </div>
                  <div class="titlefont_poslist">
                    สั่งอาหารด่วน
                  </div>
                </div>
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="check_close_store == false">
            <v-col cols="6" sm="3" md="3" lg="3" xl="3" v-for="(detail, key) in data" :key="key">
              <v-menu absolute offset-y :close-on-content-click="false" v-if="detail.status == 0">
                <template v-slot:activator="{ on, attrs }">
                  <div class="list_table_poslist" v-bind="attrs" v-on="on" @click="step = 1">
                    <img src="@/assets/table.png">
                    <div class="title_number_table_poslist d-flex justify-center align-center">โต๊ะ {{ detail.name }} ({{ detail.quantity_max }}) </div>
                  </div>
                </template>
                <v-stepper v-model="step" style="width:300px">
                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <div class="mb-2 titlefont_poslist">เปิดโต๊ะ {{ detail.name }}</div>
                      <v-btn class="mb-2 titlefont_poslist white--text grad-primary-bg" height="50" width="100%"
                        @click="nextStep(1, detail.id)">
                        บุฟเฟ่ต์
                      </v-btn>
                      <v-btn class="mb-2 titlefont_poslist white--text grad-primary-bg" height="50" width="100%"
                        @click="nextStep(0, detail.id)">
                        ทานที่ร้าน
                      </v-btn>
                      <v-btn class="mb-2 titlefont_poslist white--text q-primary-bg" height="50" width="100%"
                        @click="nextStepPreorder(4, detail.id)">
                        เรียกคิวพรีออเดอร์
                      </v-btn>
                      <v-btn color="warning" class="mb-2 titlefont_poslist" height="50" width="100%"
                        @click="openEditTableName(detail.id, detail.name)">
                        แก้ไขชื่อโต๊ะ
                      </v-btn>
                      <v-btn color="error" class="titlefont_poslist" height="50" width="100%"
                        @click="openTakeOutTable(detail.id, detail.name)">
                        เอาโต๊ะออก
                      </v-btn>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <div v-if="type == 1">
                        <div v-if="loading_ragne === true">
                          <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                          </v-sheet>
                        </div>
                        <div v-if="loading_ragne === false">
                          <div class="mb-2 d-flex justify-space-between titlefont_poslist">
                            <div>
                              เปิดโต๊ะ {{ detail.name }}
                            </div>
                            <v-card class="pl-2 pr-2 white--text grad-primary-bg">
                              บุฟเฟ่ต์
                            </v-card>
                          </div>
                          <div class="mb-2" v-for="(ragne_detail, index) in ragne_list" :key="index">
                            <v-card
                              class="py-2 titlefont_poslist white--text text-center grad-primary-bg cursor_delivery_poslist buffet_list_step_three_poslist"
                              width="100%" @click="nextStepBuffet(ragne_detail.id)">
                              {{ ragne_detail.name_ragne }}
                            </v-card>
                          </div>

                        </div>
                      </div>
                      <div v-if="type == 0">
                        <div class="mb-2 d-flex justify-space-between titlefont_poslist">
                          <div>
                            เปิดโต๊ะ {{ detail.name }}
                          </div>
                          <v-card class="pl-2 pr-2 white--text grad-primary-bg">
                            ทานที่ร้าน
                          </v-card>
                        </div>
                        <form @submit.prevent="openTableNotBuffet(detail.id)">
                          <div class="mb-2">
                            <div class="d-flex justify-center">
                              <div class="d-flex align-center h_full_poslist w_half_poslist titlefont_poslist">ลูกค้า
                              </div>
                              <div class="d-flex justify-center align-center w_half_poslist">
                                <div @click="addNumCustomerNot_buffet('minus')"
                                  class="cursor_number_table_icon_poslist">
                                  <v-icon size="40">mdi-minus-circle</v-icon>
                                </div>
                                <div class="ml-2 mr-2 titlefont_poslist">
                                  {{ add_num_customer_not_buffet }}
                                </div>

                                <div @click="addNumCustomerNot_buffet('plus')" class="cursor_number_table_icon_poslist">
                                  <v-icon size="40">mdi-plus-circle</v-icon>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="mb-2">
                            <div class="d-flex">
                              <v-checkbox class="ma-0" v-model="check_per_table" @change="checkPerTable()"></v-checkbox>
                              <div>ต่อโต๊ะ</div>
                            </div>
                            <div v-if="check_per_table == 1">
                              <div class="error--text mb-2">** เลือกได้ไม่เกิน 4 โต๊ะ **</div>
                              <v-select label="เลือกโต๊ะที่จะต่อ" :items="per_table_no_select_table_list"
                                item-text="table" item-value="id"
                                :rules="[v => v.length > 0 || 'กรุณาเลือกโต๊ะที่จะต่อ']" @input="limiterPerTable"
                                v-model="per_table" multiple required outlined>
                              </v-select>
                            </div>
                          </div>
                          <v-btn dark class="titlefont_poslist" height="50" type="submit" width="100%">
                            เปิดโต๊ะ
                          </v-btn>
                        </form>
                      </div>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                      <div v-if="loading_buffet_manage === true">
                        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                        </v-sheet>
                      </div>
                      <div v-if="loading_buffet_manage === false">
                        <div class="mb-2 d-flex justify-space-between titlefont_poslist">
                          <div>
                            เปิดโต๊ะ {{ detail.name }}
                          </div>
                          <v-card class="pl-2 pr-2 white--text grad-primary-bg">
                            {{ ragne_name }}
                          </v-card>
                        </div>
                        <form @submit.prevent="openTableBuffet(detail.id)">
                          <div class="mb-2">
                            <div class="d-flex justify-center" v-for="(buffet_choi, key_buffet) in data_buffet_choi"
                              :key="key_buffet">
                              <div class="d-flex align-center h_full_poslist w_half_poslist titlefont_poslist">{{
                                buffet_choi.name }}
                              </div>
                              <div class="d-flex justify-center align-center w_half_poslist">
                                <div @click="addNumCustomer_buffet('minus', buffet_choi.id)"
                                  class="cursor_number_table_icon_poslist">
                                  <v-icon size="40">mdi-minus-circle</v-icon>
                                </div>
                                <div class="ml-2 mr-2 titlefont_poslist">
                                  {{ buffet_choi.count }}
                                </div>

                                <div @click="addNumCustomer_buffet('plus', buffet_choi.id)"
                                  class="cursor_number_table_icon_poslist">
                                  <v-icon size="40">mdi-plus-circle</v-icon>
                                </div>
                              </div>
                            </div>

                          </div>
                          <div class="mb-2">
                            <div class="d-flex">
                              <v-checkbox color="warning" class="ma-0" v-model="check_per_table"
                                @change="checkPerTable()"></v-checkbox>
                              <div>ต่อโต๊ะ</div>
                            </div>
                            <div v-if="check_per_table == 1">
                              <div class="error--text mb-2">** เลือกได้ไม่เกิน 4 โต๊ะ **</div>
                              <v-select label="เลือกโต๊ะที่จะต่อ" :items="per_table_no_select_table_list"
                                item-text="table" item-value="id"
                                :rules="[v => v.length > 0 || 'กรุณาเลือกโต๊ะที่จะต่อ']" @input="limiterPerTable"
                                v-model="per_table" multiple required outlined>
                              </v-select>
                            </div>
                          </div>
                          <v-btn dark class="titlefont_poslist" height="50" type="submit" width="100%">
                            เปิดโต๊ะ
                          </v-btn>
                        </form>
                      </div>
                    </v-stepper-content>
                    <!-- พรีออเดอร์ -->
                    <v-stepper-content step="4">

                      <div v-if="loading_preorder === true">
                        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                        </v-sheet>
                      </div>
                      <div v-if="loading_preorder === false">
                        <form @submit.prevent="openTableBuffet_PreOrder(queue_select, detail.id)">
                          <div class="mb-2 d-flex justify-space-between titlefont_poslist">
                            <div>
                              เปิดโต๊ะ {{ detail.name }}
                            </div>
                            <v-card class="pl-2 pr-2 white--text grad-primary-bg">
                              {{ queue_select == null ? '-' : queue_show_detail.data.name_range }}
                              <!-- {{ queue_select == null ? '-' : queue_show_detail.name_pre_order }} -->
                            </v-card>
                          </div>
                          <div class="mb-2">
                            <v-select label="เลือกคิว" :items="queue_list" item-text="name_pre_order" item-value="id"
                              :rules="[v => !!v || 'กรุณาเลือกคิว']" v-model="queue_select"
                              @change="queueListDetail(queue_select)" required outlined>
                            </v-select>
                          </div>
                          <div class="mb-2">
                            <div class="d-flex">
                              <v-checkbox color="warning" class="ma-0" v-model="check_per_table"
                                @change="checkPerTable()"></v-checkbox>
                              <div>ต่อโต๊ะ</div>
                            </div>
                            <div v-if="check_per_table == 1">
                              <div class="error--text mb-2">** เลือกได้ไม่เกิน 4 โต๊ะ **</div>
                              <v-select label="เลือกโต๊ะที่จะต่อ" :items="per_table_no_select_table_list"
                                item-text="table" item-value="id"
                                :rules="[v => v.length > 0 || 'กรุณาเลือกโต๊ะที่จะต่อ']" @input="limiterPerTable"
                                v-model="per_table" multiple required outlined>
                              </v-select>
                            </div>
                          </div>
                          <!-- <div class="mb-2" v-for="(queue_detail, index) in queue_list" :key="index">
                              <v-card
                                class="py-2 titlefont_poslist white--text text-center grad-primary-bg cursor_delivery_poslist buffet_list_step_three_poslist"
                                width="100%" @click="nextStepBuffet(queue_detail.id)">
                                {{ queue_detail.name_pre_order }}
                              </v-card>
                            </div> -->

                          <v-btn dark class="titlefont_poslist" height="50" type="submit" width="100%">
                            เปิดโต๊ะ
                          </v-btn>
                        </form>
                      </div>

                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-menu>
              <div class="list_table_poslist" @click="detailPage(detail.id)" v-if="detail.status == 1">
                <img src="@/assets/table-success.png">
                <div class="title_number_table_poslist d-flex justify-center align-center flex-column">
                  <!-- โต๊ะ {{ detail.name}} -->
                  <div>โต๊ะ {{ detail.name }}</div>
                  <div class="d-flex align-center" v-if="detail.status_timer == 1">
                    <div class="mr-1">
                      <v-icon size="20" color="#ff5252">mdi-clock-time-five-outline</v-icon>
                    </div>
                    <div class="error--text">{{ detail.count_time }}</div>
                  </div>
                </div>
              </div>
              <div class="list_table_poslist" v-if="detail.status == 2">
                <img src="@/assets/table_yellowdark.png">
                <div class="title_number_table_poslist d-flex justify-center align-center">โต๊ะ {{ detail.name }}</div>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="check_close_store == true">
            <v-col cols="6" sm="3" md="3" lg="3" xl="3" v-for="(detail, key) in data" :key="key">
              <div class="list_table_poslist">
                <img src="@/assets/table.png">
                <div class="title_number_table_poslist d-flex justify-center align-center">โต๊ะ {{ detail.name }}</div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="3" lg="3" xl="3">
              <v-btn height="65" width="100%" @click="$router.push('/billretrospect')">
                <div class="d-flex justify-center align-center">
                  <div class="money_in_out_img_poslist">
                    <img src="@/assets/icon-restaurant-mini-bill.png">
                  </div>
                  <div class="titlefont_poslist">
                    บิลย้อนหลัง
                  </div>
                </div>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3" xl="3">
              <v-btn height="65" width="100%" @click="openAddNumTable()">
                <div class="add_table_poslist">
                  <img src="@/assets/icon-restaurant-mini-addtable.png">
                </div>
                <div class="titlefont_poslist">
                  เพิ่มโต๊ะ
                </div>
              </v-btn>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                <v-btn height="65" width="100%" @click="openRemoveNumTable()">
                    <div class="add_table_poslist">
                        <img src="@/assets/icon-restaurant-mini-addtable.png">
                    </div>
                    <div class="titlefont_poslist">
                        เอาโต๊ะออก
                    </div>
                </v-btn>
            </v-col> -->
            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
              <v-btn color="error" class="titlefont_poslist" height="65" width="100%"
                @click="$router.push('/summarybeforecloseshop')" v-if="check_close_store == false">
                สรุปยอดก่อนปิดร้าน
              </v-btn>
            </v-col>
          </v-row>
        </div>

      </v-card>
    </div>
    <v-dialog v-model="open_add_num_table" persistent max-width="600px">
      <v-card>
        <form @submit.prevent="addTable()">
          <v-card-title>
            <div class="d-flex justify-center align-center">
              <div class="img_title_modal_poslist">
                <img src="@/assets/icon-restaurant-mini-addtable.png">
              </div>
              <div class="title_modal_poslist">
                เพิ่มโต๊ะ
              </div>
            </div>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <div class="text-center">กรุณากรอกจำนวนโต๊ะที่ต้องการเพิ่ม</div>
                  <div class="d-flex justify-center align-center add_number_table_poslist">
                    <div @click="addNumTable('minus')" class="cursor_number_table_icon_poslist">
                      <v-icon size="30">mdi-minus-circle</v-icon>
                    </div>
                    <div class="ml-2 mr-2">
                      {{ add_num_table }}
                    </div>
                    <div @click="addNumTable('plus')" class="cursor_number_table_icon_poslist">
                      <v-icon size="30">mdi-plus-circle</v-icon>
                    </div>
                  </div>
                </v-col>

                <v-col cols="6">
                  <div class="text-center">กรุณากรอกจำนวนคนสูงสุดที่นั่งได้</div>
                  <div class="d-flex justify-center align-center add_number_table_poslist">
                    <div @click="addNumTableUser('minus')" class="cursor_number_table_icon_poslist">
                      <v-icon size="30">mdi-minus-circle</v-icon>
                    </div>
                    <div class="ml-2 mr-2">
                      {{ add_num_table_user }}
                    </div>
                    <div @click="addNumTableUser('plus')" class="cursor_number_table_icon_poslist">
                      <v-icon size="30">mdi-plus-circle</v-icon>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#28ab28" class="white--text titlefont_poslist" type="submit" height="50">
              เพิ่ม
            </v-btn>
            <v-btn color="error" class="titlefont_poslist" type="button" height="50"
              @click="open_add_num_table = false">
              ยกเลิก
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="open_remove_num_table" persistent max-width="600px">
      <v-card>
        <form @submit.prevent="removeTable()">
          <v-card-title>
            <div class="d-flex justify-center align-center">
              <div class="img_title_modal_poslist">
                <img src="@/assets/icon-restaurant-mini-addtable.png">
              </div>
              <div class="title_modal_poslist">
                เอาโต๊ะออก
              </div>
            </div>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div class="text-center">กรุณากรอกจำนวนโต๊ะที่ต้องการเอาออก</div>
                  <div class="d-flex justify-center align-center add_number_table_poslist">
                    <div @click="removeNumTable('minus')" class="cursor_number_table_icon_poslist">
                      <v-icon size="30">mdi-minus-circle</v-icon>
                    </div>
                    <div class="ml-2 mr-2">
                      {{ remove_num_table }}
                    </div>
                    <div @click="removeNumTable('plus')" class="cursor_number_table_icon_poslist">
                      <v-icon size="30">mdi-plus-circle</v-icon>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#28ab28" class="white--text titlefont_poslist" type="submit" height="50">
              บันทึก
            </v-btn>
            <v-btn color="error" class="titlefont_poslist" type="button" height="50"
              @click="open_remove_num_table = false">
              ยกเลิก
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="open_money_in_out" persistent>
      <div v-if="loading_page_money_in_out === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
      </div>
      <div v-if="loading_page_money_in_out === false">
        <v-card>

          <v-card-title class="justify-space-between">
            <span>เงินเข้า</span>
            <div class="cursor_number_table_icon_poslist" @click="open_money_in_out = false">
              <v-icon>mdi-close</v-icon>
            </div>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="5" lg="5" xl="5">
                  <v-form ref="form_money_in_out" @submit.prevent="addMoneyInOut()">
                    <v-text-field color="primary" label="กรุณาใส่จำนวนเงิน" v-model="money_in_out_price" type="number"
                      :rules="[v => !!v || 'กรุณากรอกจำนวนเงิน']" @keyup="setMoneyInOutPriceAccept()" required
                      outlined></v-text-field>
                    <v-text-field color="primary" label="รับเงิน" v-model="money_in_out_price_accept" type="number"
                      @keyup="setMoneyInOutPriceAcceptAll()" outlined></v-text-field>
                    <h2 class="mb-2">เงินทอน {{ Intl.NumberFormat().format(money_in_out_price_accept_all) }} บาท</h2>
                    <div class="d-flex justify-space-between">
                      <div>ตัวเลือก</div>
                      <div class="blue--text add_delivery_poslist cursor_delivery_poslist" @click="openDeliveryAdd()">
                        + เพิ่มเดริเวอร์รี่
                      </div>
                    </div>
                    <v-radio-group class="mt-0 money_in_out_select_poslist" v-model="money_in_out_name">
                      <div class="check_delivery_poslist">
                        <div class="d-flex justify-space-between align-center mb-3"
                          v-for="(money_in_out_name_detail, index) in money_in_out_name_list" :key="index">
                          <div class="d-flex mr-1">
                            <v-radio color="primary" class="mb-0" :value="money_in_out_name_detail.id"></v-radio>
                            <div>{{ money_in_out_name_detail.debtor_name }}</div>
                          </div>
                          <div class="d-flex">
                            <v-icon size="20"
                              @click="detailDelivery(money_in_out_name_detail.id)">mdi-pencil-box</v-icon>
                            <v-icon size="20"
                              @click="openConfirmDeleteDelivery(money_in_out_name_detail.id, money_in_out_name_detail.debtor_name)">mdi-delete</v-icon>
                          </div>

                        </div>
                      </div>
                    </v-radio-group>
                    <v-textarea class="mt-2" color="primary" label="หมายเหตุ" v-model="money_in_out_description"
                      rows="3" outlined>
                    </v-textarea>
                    <div class="d-flex justify-space-between">
                      <v-btn color="success" width="40%" type="submit" @click="money_in_out_value = 0"
                        class="titlefont_poslist" height="50">เงินสด</v-btn>
                      <v-btn color="#2f4f4f" width="40%" type="submit" @click="money_in_out_value = 1"
                        class="titlefont_poslist white--text" height="50">เงินโอน</v-btn>
                    </div>
                  </v-form>
                </v-col>
                <v-col cols="12" sm="12" md="7" lg="7" xl="7">
                  <div class="d-flex justify-space-between mb-3 titlefont_money_inout_poslist">
                    <div>ยอดเงินรวม</div>
                    <div>{{ Intl.NumberFormat().format(money_in_out_all) }}</div>
                  </div>
                  <div>
                    <v-card v-for="(detail_money_in_out, key_money_in_out) in data_money_in_out"
                      :key="key_money_in_out">
                      <div class="d-flex justify-space-between pa-3 mb-2">
                        <div class="d-flex money_in_out_detail_poslist">
                          <div>
                            <v-icon>mdi-timer-outline</v-icon>
                          </div>
                          <div>
                            <div>{{ detail_money_in_out.created_at }}</div>
                            <div>{{ detail_money_in_out.name }}</div>
                            <div v-if="detail_money_in_out.description !== null">
                              {{ detail_money_in_out.description }}
                            </div>
                            <div class="error--text" v-if="detail_money_in_out.status_delete == 1">
                              หมายเหตุในการยกเลิก ** {{ detail_money_in_out.description_delete }} **
                            </div>
                          </div>
                        </div>
                        <div class="d-flex justify-end align-center money_in_out_detail_poslist"
                          v-if="detail_money_in_out.status_delete == 0">
                          <v-card
                            :color="detail_money_in_out.status == 1 ? '#2f4f4f' : detail_money_in_out.status == 0 ? 'success' : ''"
                            class="d-flex justify-center align-center titlefont_poslist white--text" width="80%"
                            height="50">
                            {{ detail_money_in_out.status == 1 ? Intl.NumberFormat().format(detail_money_in_out.price) :
                              detail_money_in_out.status == 0 ? Intl.NumberFormat().format(detail_money_in_out.price) :
                            "" }}
                          </v-card>
                          <div class="money_in_out_delete_poslist"
                            @click="openConfirmDeleteMoneyInOut(detail_money_in_out.id)">
                            <v-icon>mdi-delete</v-icon>
                          </div>
                        </div>

                        <div class="d-flex justify-end align-center money_in_out_detail_poslist"
                          v-if="detail_money_in_out.status_delete == 1">
                          <v-card color="error" class="d-flex justify-center align-center titlefont_poslist white--text"
                            width="80%" height="50">
                            {{ detail_money_in_out.status == 1 ? Intl.NumberFormat().format(detail_money_in_out.price) :
                              detail_money_in_out.status == 0 ? Intl.NumberFormat().format(detail_money_in_out.price) :
                            "" }}
                          </v-card>
                        </div>

                      </div>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <!-- <v-spacer></v-spacer>
            <v-btn color="error" type="button" height="50" @click="open_money_in_out = false">
                ปิด
            </v-btn> -->
          </v-card-actions>

        </v-card>
      </div>
    </v-dialog>
    <v-dialog v-model="open_shop" persistent max-width="600px">
      <div v-if="loading_page_open_shop === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
      </div>
      <div v-if="loading_page_open_shop === false">
        <v-card>
          <v-form ref="form_open_shop" @submit.prevent="openShop()">
            <v-card-title>
              <span>เปิดร้าน</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <div class="text-center">เปิดรอบลิ้นชัก</div>
                    <div>
                      <v-text-field label="กรุณากรอกเงินสดที่อยู่ในลิ้นชัก" type="number"
                        @keypress="isNumberPrice($event)" onpaste="return false" v-model="money_open"
                        :rules="[v => !!v || 'กรุณากรอกเงินสดที่อยู่ในลิ้นชัก']" required outlined></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#28ab28" class="white--text titlefont_poslist" type="submit" height="50">
                เปิดรอบ
              </v-btn>
              <v-btn color="error" class="titlefont_poslist" type="button" height="50"
                @click="$router.push('/restaurant')">
                ยกเลิก
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </div>
    </v-dialog>
    <v-dialog v-model="open_close_shop" persistent max-width="600px">
      <div v-if="loading_page_close_shop === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
      </div>
      <div v-if="loading_page_close_shop === false">
        <v-card>
          <!-- <v-form ref="form_close_shop" @submit.prevent="closeShop()"> -->
          <v-form>
            <v-card-title>
              <span>ปิดร้าน</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <div class="text-center">ปิดรอบลิ้นชัก</div>
                    <div>
                      <v-text-field label="กรุณากรอกเงินสดที่อยู่ในลิ้นชัก" type="number" v-model="money_close"
                        :rules="[v => !!v || 'กรุณากรอกเงินสดที่อยู่ในลิ้นชัก']" required outlined></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#28ab28" class="white--text titlefont_poslist" type="submit" height="50">
                ปิดรอบ
              </v-btn>
              <v-btn color="error" class="titlefont_poslist" type="button" height="50" @click="open_close_shop = false">
                ยกเลิก
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </div>
    </v-dialog>

    <v-dialog v-model="alert_editTableName" persistent max-width="600">
      <v-card>
        <form @submit.prevent="editTableName()">
          <v-card-title>
            แก้ไขชื่อโต๊ะ {{ table_editTableName_name }}
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="6">
                <v-text-field v-model="table_editTableName_new_name" color="primary"
                  label="ชื่อโต๊ะ (ไม่เกิน 10 ตัวอักษร)" maxlength="10" :rules="[v => !!v || 'กรุณากรอกชื่อโต๊ะ']"
                  required outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                  <div class="text-center">กรุณากรอกจำนวนคนสูงสุดที่นั่งได้</div>
                  <div class="d-flex justify-center align-center add_number_table_poslist">
                    <div @click="addNumTableUserEdit('minus')" class="cursor_number_table_icon_poslist">
                      <v-icon size="30">mdi-minus-circle</v-icon>
                    </div>
                    <div class="ml-2 mr-2">
                      {{ table_editTable_user }}
                    </div>
                    <div @click="addNumTableUserEdit('plus')" class="cursor_number_table_icon_poslist">
                      <v-icon size="30">mdi-plus-circle</v-icon>
                    </div>
                  </div>
              </v-col>
            </v-row>

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#28ab28" class="white--text" type="submit">
              ตกลง
            </v-btn>
            <v-btn color="error" @click="alert_editTableName = false">
              ยกเลิก
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="alert_takeOut" persistent max-width="600">
      <v-card>
        <form @submit.prevent="takeOutTable()">
          <v-card-title>
            เอาโต๊ะออก
          </v-card-title>

          <v-card-text>
            ต้องการเอาโต๊ะ {{ table_takeOut_name }} ออกใช่หรือไม่ ??
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#28ab28" class="white--text" type="submit">
              ตกลง
            </v-btn>
            <v-btn color="error" @click="alert_takeOut = false">
              ยกเลิก
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="alert_money_in_out" persistent max-width="600">
      <v-card>
        <v-form ref="form_remove_money_in_out" @submit.prevent="removeMoney_in_out()">
          <v-card-title>
            ต้องการลบ
          </v-card-title>

          <v-card-text>
            <div class="mb-2">
              ต้องการลบ เงินเข้า/เงินออก นี้ใช่หรือไม่ ??
            </div>
            <div class="mb-2">
              <v-select label="เหตุผลในการยกเลิกเงินเข้า/เงินออก" v-model="remove_money_in_out_description"
                :items="$store.state.reasonCancelBill" color="primary" hide-details="auto"
                :rules="[v => !!v || 'กรุณาเลือกเหตุผลในการยกเลิกเงินเข้า/เงินออก']"
                @change="removeMoneyInOutDescription()" required outlined>
              </v-select>
            </div>
            <div class="mb-2" v-if="remove_money_in_out_reason_check">
              <v-text-field v-model="remove_money_in_out_reason" color="primary" label="เหตุผลในการยกเลิกบิล"
                :rules="[v => !!v || 'กรุณากรอกเหตุผลในการยกเลิกเงินเข้า/เงินออก']" required outlined></v-text-field>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#28ab28" class="white--text" type="submit">
              ตกลง
            </v-btn>
            <v-btn color="error" @click="alert_money_in_out = false">
              ยกเลิก
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- เพิ่มเดริเวอร์รี่ -->
    <v-dialog v-model="open_add_delivery" persistent max-width="600px">

      <v-card>
        <v-form ref="form_delivery_add" @submit.prevent="addDelivery()">
          <v-card-title class="justify-space-between">
            <div>
              เพิ่มเดริเวอร์รี่
            </div>
            <div class="cursor_delivery_poslist" @click="open_add_delivery = false">
              <v-icon>mdi-close</v-icon>
            </div>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>

                <v-col cols="12">
                  <v-text-field label="ลูกหนี้" v-model="delivery_name" :rules="[v => !!v || 'กรุณากรอกลูกหนี้']"
                    required outlined></v-text-field>
                  <v-text-field label="ค่าบริการ (%)" type="number" v-model="delivery_service"
                    :rules="[v => !!v || 'กรุณากรอกค่าบริการ (%)']" required outlined></v-text-field>
                  <v-text-field label="VAT (%)" type="number" v-model="delivery_vat"
                    :rules="[v => !!v || 'กรุณากรอกVAT (%)']" required outlined></v-text-field>
                  <div class="d-flex align-center mb-2">
                    <div class="mr-1">สามารถเลือกรหัสสีได้ที่นี่</div>
                    <v-input-colorpicker v-model="delivery_color_code" class="colorpicker_poslist" />
                  </div>
                  <v-text-field label="รหัสสี" v-model="delivery_color_code" :rules="[v => !!v || 'กรุณาเลือกรหัสสี']"
                    required outlined></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- แก้ไขเดริเวอร์รี่ -->
    <v-dialog v-model="open_edit_delivery" persistent max-width="600px">
      <div v-if="loading_edit_delivery_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
      </div>
      <v-card v-if="loading_edit_delivery_page === false">
        <v-form ref="form_delivery_edit" @submit.prevent="editDelivery()">
          <v-card-title class="justify-space-between">
            <div>
              แก้ไขเดริเวอร์รี่
            </div>
            <div class="cursor_delivery_poslist" @click="open_edit_delivery = false">
              <v-icon>mdi-close</v-icon>
            </div>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>

                <v-col cols="12">
                  <v-text-field label="ลูกหนี้" v-model="edit_delivery_name" :rules="[v => !!v || 'กรุณากรอกลูกหนี้']"
                    required outlined></v-text-field>
                  <v-text-field label="ค่าบริการ (%)" type="number" v-model="edit_delivery_service"
                    :rules="[v => !!v || 'กรุณากรอกค่าบริการ (%)']" required outlined></v-text-field>
                  <v-text-field label="VAT (%)" type="number" v-model="edit_delivery_vat"
                    :rules="[v => !!v || 'กรุณากรอกVAT (%)']" required outlined></v-text-field>
                  <div class="d-flex align-center mb-2">
                    <div class="mr-1">สามารถเลือกรหัสสีได้ที่นี่</div>
                    <v-input-colorpicker v-model="edit_delivery_color_code" class="colorpicker_poslist" />
                  </div>
                  <v-text-field label="รหัสสี" v-model="edit_delivery_color_code"
                    :rules="[v => !!v || 'กรุณาเลือกรหัสสี']" required outlined></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- ยืนยันลบดริเวอร์รี่ -->
    <v-dialog v-model="open_confirm_delete_delivery" persistent max-width="600px">
      <v-card>
        <v-card-title>
          คำเตือน
        </v-card-title>
        <v-card-text>
          ต้องการลบเดริเวอร์รี่ {{ delete_delivery_name }} ใช่หรือไม่ ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#28ab28" class="white--text" height="50" @click="deleteDelivery()">
            บันทึก
          </v-btn>
          <v-btn color="error" height="50" @click="closeConfirmDeliveryDelete()">
            ยกเลิก
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- แจ้งเตือนการหมดเวลาบุฟเฟต์ -->
    <v-dialog v-model="open_notification_timeout_buffet" persistent max-width="600px">
      <div v-if="loading_notification_timeout_buffet === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
      </div>
      <v-card v-if="loading_notification_timeout_buffet === false">
        <v-card-title class="justify-space-between">
          <span>แจ้งเตือนการหมดเวลาบุฟเฟต์</span>
          <div class="cursor_number_table_icon_poslist" @click="closeNotificationTimeoutBuffet()">
            <v-icon>mdi-close</v-icon>
          </div>
        </v-card-title>

        <v-card-text>
          <h2 class="mb-2">โต๊ะ {{ notification_table_name }} : บุฟเฟ่ต์ {{ notification_table_type }}</h2>
          <div class="clock_notification_image mb-2">
            <img src="@/assets/alarm-clock.png">
          </div>
          <h2 class="error--text text-center mb-4">
            ครบเวลา {{ notification_table_time }}
          </h2>
          <div class="text-center">
            <v-btn class="grad-primary-bg white--text" height="50" width="40%"
              @click="confirmNotificationTimeoutBuffet()">
              ปิดการเตือน
            </v-btn>
          </div>
        </v-card-text>

        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  HTTP
} from "@/axios.js"
import assignrelevantpeopleall from '@/api/account/accountsetting/assignrelevantpeopleall.js'
import MenuPos from '@/components/menuadmin/MenuPos.vue'
import InputColorPicker from 'vue-native-color-picker'
export default {
  name: 'posList',
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  components: {
    MenuPos,
    "v-input-colorpicker": InputColorPicker,
  },
  data() {
    return {
      loading_page: true,
      loading_ragne: true,
      loading_buffet_manage: true,
      loading_preorder: true,
      loading_page_money_in_out: true,
      open_shop: false,
      money_open: null,
      loading_page_open_shop: false,
      alert_error_amount_buffet: false,
      alert_error_amount_no_buffet: false,
      alert_add_num_table: false,
      alert_add_num_table_user: false,
      open_add_num_table: false,
      add_num_table: 0,
      add_num_table_user: 0,
      alert_remove_num_table: false,
      alert_error_remove_num_table: false,
      message_error_remove_num_table: null,
      open_remove_num_table: false,
      remove_num_table: 0,
      data: [],
      ragne_list: [],
      ragne_id: null,
      ragne_name: null,
      queue_list: [],
      queue_select: null,
      queue_show_detail: null,
      data_buffet_choi: [],
      step: 1,
      type: null,
      add_num_customer_not_buffet: 0,
      open_close_shop: false,
      money_close: null,
      loading_page_close_shop: false,
      alert_editTableName: false,
      table_editTableName_id: null,
      table_editTableName_name: null,
      table_editTableName_new_name: null,
      table_editTable_user: null,
      alert_edit_table_name_success: false,
      alert_takeOut: false,
      table_takeOut_id: null,
      table_takeOut_name: null,
      alert_table_takeout_success: false,
      open_money_in_out: false,
      data_money_in_out: [],
      money_in_out_all: 0,
      money_in_out_price: null,
      money_in_out_price_accept: null,
      money_in_out_price_accept_all: 0,
      money_in_out_name_list: [],
      money_in_out_name: null,
      money_in_out_description: null,
      money_in_out_value: null,
      alert_money_in_out: false,
      alert_money_in_out_notify: false,
      remove_money_in_out_description: null,
      remove_money_in_out_reason_check: false,
      remove_money_in_out_reason: null,
      message_remove_money_in_out: false,
      money_in_out_delete_id: null,
      alert_error_close_shop: false,
      message_error_close_shop: null,
      open_add_delivery: false,
      alert_delivery: null,
      delivery_name: null,
      delivery_service: null,
      delivery_vat: null,
      delivery_color_code: null,
      open_edit_delivery: false,
      loading_edit_delivery_page: true,
      alert_edit_delivery: null,
      edit_delivery_id: null,
      edit_delivery_name: null,
      edit_delivery_service: null,
      edit_delivery_vat: null,
      edit_delivery_color_code: null,
      open_confirm_delete_delivery: false,
      alert_delete_delivery: false,
      delete_delivery_id: null,
      delete_delivery_name: null,
      alert_error_per_table: false,
      check_per_table: 0,
      per_table: [],
      per_table_list: [],
      per_table_no_select_table_list: [],
      check_close_store: true,
      alert_error_open_table: false,
      message_error_open_table: null,
      open_notification_timeout_buffet: false,
      loading_notification_timeout_buffet: false,
      notification_table_name: null,
      notification_table_type: null,
      notification_table_time: null,
      notification_table_bell_status: null,
      notification_table_opentable_id: null,
      table_editTable_user:0,
    }
  },
  methods: {
    async isNumberPrice(evt) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async checkOpenShop() {
      this.loading_page = true
      HTTP.get('/money-drawer-check', {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
        .then((response) => {
          if (response.data.successful === false) {
            this.open_shop = true
          }
        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })

    },
    // async quickFoodOrderPage() {
    //     this.loading_page = true
    //     HTTP.post('/fastOrdercreateTakhome', null, {
    //             headers: {
    //                 "Authorization": `Bearer ${this.$store.state.token}`
    //             }
    //         })
    //         .then((response) => {
    //             if (response.data.successful === true) {
    //                 const tokenPage = {
    //                     token: response.data.token,
    //                 }
    //                 this.$store.commit('tokenQuickFoodOrderPage', tokenPage)
    //                 const idPage = {
    //                     id: response.data.id,
    //                 }
    //                 this.$store.commit('invoiceQuickFoodOrderPage', idPage)
    //                 this.$router.push('/quickfoodorder')
    //             }

    //         }).catch((error) => {
    //             if (error.response.status === 401) {
    //                 this.$store.commit('logOutSuccess')
    //                 this.$router.push('/login')
    //             }
    //         })

    // },
    async openAddNumTable() {
      this.open_add_num_table = true
      this.add_num_table = 0
    },
    async addNumTable(type) {
      if (type === 'plus') {
        this.add_num_table += 1
      }
      if (type === 'minus' && this.add_num_table > 0) {
        this.add_num_table -= 1
      }
    },
    async addNumTableUser(type) {
      if (type === 'plus') {
        this.add_num_table_user += 1
      }
      if (type === 'minus' && this.add_num_table_user > 0) {
        this.add_num_table_user -= 1
      }
    },
    async addNumTableUserEdit(type) {
      if (type === 'plus') {
        this.table_editTable_user += 1
      }
      if (type === 'minus' && this.table_editTable_user > 0) {
        this.table_editTable_user -= 1
      }
    },
    async openRemoveNumTable() {
      this.open_remove_num_table = true
      this.remove_num_table = 0
    },
    async removeNumTable(type) {
      if (type === 'plus' && this.remove_num_table < this.data.length) {
        this.remove_num_table += 1
      }
      if (type === 'minus' && this.remove_num_table > 0) {
        this.remove_num_table -= 1
      }
    },
    async nextStep(type, table_id) {
      if (type === 1) {
        await this.ragneList()
      }
      this.add_num_customer_not_buffet = 0
      this.step = 2
      this.type = type
      this.check_per_table = 0
      this.per_table = []
      this.per_table_no_select_table_list = this.per_table_list.filter((detail) => { return detail.id != table_id })
    },
    async nextStepBuffet(id) {
      await this.getBuffetManage(id)
      this.step = 3
    },
    async nextStepPreorder(type, table_id) {
      await this.queueList()
      this.add_num_customer_not_buffet = 0
      this.step = 4
      this.type = type
      this.check_per_table = 0
      this.per_table = []
      this.per_table_no_select_table_list = this.per_table_list.filter((detail) => { return detail.id != table_id })
      this.loading_preorder = false
    },
    async addNumCustomer_buffet(type, id) {
      const result_buffet = this.data_buffet_choi.find((detail) => {
        return detail.id == id
      })

      if (type === 'plus') {
        result_buffet.count += 1
      }
      if (type === 'minus' && result_buffet.count > 0) {
        result_buffet.count -= 1
      }
    },
    async addNumCustomerNot_buffet(type) {
      if (type === 'plus') {
        this.add_num_customer_not_buffet += 1
      }
      if (type === 'minus' && this.add_num_customer_not_buffet > 0) {
        this.add_num_customer_not_buffet -= 1
      }
    },
    async openEditTableName(id, name) {
      this.alert_editTableName = true
      this.table_editTableName_id = id
      this.table_editTableName_name = name
    },
    async openTakeOutTable(id, name) {
      this.alert_takeOut = true
      this.table_takeOut_id = id
      this.table_takeOut_name = name
    },
    async tableList() {
      this.loading_page = true
      HTTP.get('/POS/table/all', {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
        .then((response) => {
          if (response.data.successful === true) {
            response.data.table.forEach((detail, index) => {
              response.data.table[index]['count_time'] = '00 : 00 : 00'
              response.data.table[index]['notification_timeout_buffet'] = true
            })
            this.data = response.data.table
          }

        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
    },
    async listPerTable() {
      this.loading_page = true
      this.check_per_table = 0
      this.per_table = []
      this.per_table_list = []
      HTTP.get('/POS/listTable', {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
        .then((response) => {
          if (response.data.successful === true) {
            this.per_table_list = response.data.list
          }
        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
    },
    async checkCloseStore() {
      this.loading_page = false
      this.check_close_store = false
      // this.loading_page = true
      // HTTP.get('/check_close_store', {
      //   headers: {
      //     "Authorization": `Bearer ${this.$store.state.token}`
      //   }
      // })
      //     .then((response) => {
      //       if (response.data.successful === true) {
      //         this.loading_page = false
      //         this.check_close_store = true
      //       }
      //       if (response.data.successful === false) {
      //         this.loading_page = false
      //         this.check_close_store = false
      //       }
      //     }).catch((error) => {
      //   if (error.response.status === 401) {
      //     this.$store.commit('logOutSuccess')
      //     this.$router.push('/login')
      //   }
      // })
    },
    async listData() {
      await this.checkOpenShop()
      await this.tableList()
      await this.listPerTable()
      await this.checkCloseStore()
    },
    async openShop() {

      if (this.$refs.form_open_shop.validate()) {
        this.loading_page_open_shop = true
        await HTTP.post('/money-drawer/open-and-close', {
          money: this.money_open,
          status: 0
        }, {
          headers: {
            "Authorization": `Bearer ${this.$store.state.token}`
          }
        })
          .then((response) => {
            if (response.data.successful === true) {
              this.open_shop = false
              this.loading_page_open_shop = false
              this.listData()
            }

          }).catch((error) => {
            if (error.response.status === 401) {
              this.$store.commit('logOutSuccess')
              this.$router.push('/login')
            }
          })
      }
    },
    async openCloseShop() {
      this.open_close_shop = true
      this.money_close = null
    },
    async closeShop() {
      if (this.$refs.form_close_shop.validate()) {
        this.loading_page_close_shop = true
        HTTP.post('/money-drawer/close', {
          money: this.money_close,
        }, {
          headers: {
            "Authorization": `Bearer ${this.$store.state.token}`
          }
        })
          .then((response) => {
            if (response.data.successful === true) {
              this.loading_page_close_shop = false
              this.$router.push('/salereportday')
            }
            if (response.data.successful === false) {
              this.open_close_shop = false
              this.loading_page_close_shop = false
              this.money_close = null
              this.message_error_close_shop = response.data.message
              this.alert_error_close_shop = true
              setTimeout(() => this.alert_error_close_shop = false, 5000)
            }

          }).catch((error) => {
            if (error.response.status === 401) {
              this.$store.commit('logOutSuccess')
              this.$router.push('/login')
            }
          })
      }
    },
    async addTable() {
      this.loading_page = true
      this.open_add_num_table = false
      HTTP.post('/POS/table/add', {
        num: this.add_num_table,
        quantity_max: this.add_num_table_user
      }, {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
        .then((response) => {
          if (response.data.successful === true) {
            this.alert_add_num_table = true
            setTimeout(() => this.alert_add_num_table = false, 5000)
            this.listData()
          }
        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
    },
    async removeTable() {
      if (this.remove_num_table > 0) {
        this.loading_page = true
        this.open_remove_num_table = false
        HTTP.post('/POS/table/delete', {
          amount: this.remove_num_table
        }, {
          headers: {
            "Authorization": `Bearer ${this.$store.state.token}`
          }
        })
          .then((response) => {
            if (response.data.successful === true) {
              this.alert_remove_num_table = true
              setTimeout(() => this.alert_remove_num_table = false, 5000)
              this.listData()
            }
            if (response.data.successful === false) {
              this.message_error_remove_num_table = response.data.msg
              this.alert_error_remove_num_table = true
              setTimeout(() => this.alert_error_remove_num_table = false, 5000)
              this.loading_page = false
            }

          }).catch((error) => {
            if (error.response.status === 401) {
              this.$store.commit('logOutSuccess')
              this.$router.push('/login')
            }
          })
      }
    },
    async editTableName() {
      this.loading_page = true
      this.alert_editTableName = false
      HTTP.post('/POS/table/chenge_table_name/' + this.table_editTableName_id, {
        name: this.table_editTableName_new_name.replace(this.$store.state.checkEmoji, ""),
        quantity_max:this.table_editTable_user
      }, {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
        .then((response) => {
          if (response.data.successful === true) {
            this.table_editTableName_id = null
            this.table_editTableName_name = null
            this.table_editTableName_new_name = null
            this.alert_edit_table_name_success = true
            setTimeout(() => this.alert_edit_table_name_success = false, 5000)
            this.listData()
          }

        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
    },
    async takeOutTable() {
      this.loading_page = true
      this.alert_takeOut = false
      HTTP.post('/POS/table/delete', {
        id: this.table_takeOut_id
      }, {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
        .then((response) => {
          if (response.data.successful === true) {
            this.table_takeOut_id = null
            this.table_takeOut_name = null
            this.alert_table_takeout_success = true
            setTimeout(() => this.alert_table_takeout_success = false, 5000)
            this.listData()
          }

        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
    },
    async ragneList() {
      this.loading_ragne = true
      this.ragne_list = []
      HTTP.get('/POS/table/list_ragne', {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
        .then((response) => {
          if (response.data.successful === true) {
            response.data.ragneList.forEach((detail, index) => {
              if (index > 1) {
                this.ragne_list.push({
                  id: detail.id,
                  name_ragne: detail.name_ragne,
                })
              }
            })
            this.loading_ragne = false
          }
        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
    },
    async queueList() {
      this.loading_ragne = true
      this.queue_list = []
      HTTP.get('/preorder/table/list', {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
        .then((response) => {
          if (response.data.successful === true) {
            this.queue_list = response.data.data
            this.loading_ragne = false
          }
        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
    },
    async queueListDetail(id) {
      this.loading_ragne = true
      this.queue_show_detail = null
      HTTP.get('preorder/table/detail/' + id, {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
        .then((response) => {
          if (response.data.successful === true) {
            this.queue_show_detail = response.data
            console.log(response.data);
            this.loading_ragne = false
          }
        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
    },
    async getBuffetManage(id) {
      this.loading_buffet_manage = true
      this.ragne_id = id
      const ragne_detail = this.ragne_list.find((detail) => { return detail.id == id })
      this.ragne_name = ragne_detail.name_ragne
      HTTP.get('/POS/table/buffet-choi/' + id, {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
        .then((response) => {
          if (response.data.successful === true) {
            for (let index = 0; index < response.data.buffet.length; index++) {
              response.data.buffet[index].count = 0

            }
            this.data_buffet_choi = response.data.buffet
            this.loading_buffet_manage = false
          }

        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
    },
    async openTableBuffet(id) {
      let status_table = 0
      if (this.check_per_table === true || this.check_per_table == 1) {
        status_table = 1
      }
      const result_id = this.data_buffet_choi.map((detail) => detail.id);
      const result_amount = this.data_buffet_choi.map((detail) => detail.count);
      const checkResult_amount = result_amount.reduce((sum, number) => sum + number, 0)

      if (checkResult_amount <= 0) {
        this.alert_error_amount_buffet = true
        setTimeout(() => this.alert_error_amount_buffet = false, 5000)
      } else {
        if (status_table == 1 && this.per_table.length <= 0) {
          this.alert_error_per_table = true
          setTimeout(() => this.alert_error_per_table = false, 5000)
        } else {
          this.loading_page = true
          HTTP.post('/POS/table/open-table-buffet', {
            table_id: id,
            status_table: status_table,
            tables: this.per_table,
            type: "บุฟเฟ่",
            ragne_id: this.ragne_id,
            id: result_id,
            amount: result_amount
          }, {
            headers: {
              "Authorization": `Bearer ${this.$store.state.token}`
            }
          })
            .then((response) => {
              if (response.data.successful === true) {
                this.data_buffet_choi = []
                this.table_takeOut_id = null
                this.table_takeOut_name = null
                this.add_num_customer_not_buffet = 0
                const idPage = {
                  id: id,
                }
                this.$store.commit('detailTablePage', idPage)
                this.$store.commit('quickFoodStatus', null)
                window.location.href = '/postabledetail';
              }
              if (response.data.successful === false) {
                this.message_error_open_table = response.data.msg
                this.alert_error_open_table = true
                setTimeout(() => this.alert_error_open_table = false, 5000)
                this.loading_page = false
              }

            }).catch((error) => {
              if (error.response.status === 401) {
                this.$store.commit('logOutSuccess')
                this.$router.push('/login')
              }
            })
        }
      }
    },

    async openTableBuffet_PreOrder(id, table_id) {
      let status_table = 0
      if(this.queue_select == null || this.queue_select == '') {
        return;
      }
      if (this.check_per_table === true || this.check_per_table == 1) {
        status_table = 1
      }

      if (status_table == 1 && this.per_table.length <= 0) {
        this.alert_error_per_table = true
        setTimeout(() => this.alert_error_per_table = false, 5000)
      } else {
        this.loading_page = true
        HTTP.post('/open/table/by/preorder', {
          id: id,
          opentable_id: id,
          table_id: table_id,
          status_table: status_table,
          tables: this.per_table,
        }, {
          headers: {
            "Authorization": `Bearer ${this.$store.state.token}`
          }
        })
          .then((response) => {
            if (response.data.successful === true) {
              this.data_buffet_choi = []
              this.table_takeOut_id = null
              this.table_takeOut_name = null
              this.add_num_customer_not_buffet = 0
              const idPage = {
                id: table_id,
              }
              this.$store.commit('detailTablePage', idPage)
              this.$store.commit('quickFoodStatus', null)
              window.location.href = '/postabledetail';
            }
            if (response.data.successful === false) {
              this.message_error_open_table = response.data.msg
              this.alert_error_open_table = true
              setTimeout(() => this.alert_error_open_table = false, 5000)
              this.loading_page = false
            }

          }).catch((error) => {
            if (error.response.status === 401) {
              this.$store.commit('logOutSuccess')
              this.$router.push('/login')
            }
          })
      }

    },

    async openTableNotBuffet(id) {
      let status_table = 0
      if (this.check_per_table === true) {
        status_table = 1
      }
      if (this.add_num_customer_not_buffet <= 0) {
        this.alert_error_amount_no_buffet = true
        setTimeout(() => this.alert_error_amount_no_buffet = false, 5000)
      } else {
        if (status_table == 1 && this.per_table.length <= 0) {
          this.alert_error_per_table = true
          setTimeout(() => this.alert_error_per_table = false, 5000)
        } else {
          this.loading_page = true
          HTTP.post('/POS/table/open-table-not-buffet', {
            table_id: id,
            status_table: status_table,
            tables: this.per_table,
            type: "ไม่บุฟเฟ่",
            amount: this.add_num_customer_not_buffet
          }, {
            headers: {
              "Authorization": `Bearer ${this.$store.state.token}`
            }
          })
            .then((response) => {
              if (response.data.successful === true) {
                this.data_buffet_choi = []
                this.table_takeOut_id = null
                this.table_takeOut_name = null
                this.add_num_customer_not_buffet = 0
                const idPage = {
                  id: id,
                }
                this.$store.commit('detailTablePage', idPage)
                this.$store.commit('quickFoodStatus', null)
                window.location.href = '/postabledetail';
              }
              if (response.data.successful === false) {
                this.message_error_open_table = response.data.msg
                this.alert_error_open_table = true
                setTimeout(() => this.alert_error_open_table = false, 5000)
                this.loading_page = false
              }

            }).catch((error) => {
              if (error.response.status === 401) {
                this.$store.commit('logOutSuccess')
                this.$router.push('/login')
              }
            })
        }
      }
    },
    async detailPage(id) {
      const idPage = {
        id: id,
      }
      this.$store.commit('detailTablePage', idPage)
      this.$store.commit('quickFoodStatus', null)
      // this.$router.push('/postabledetail')
      window.location.href = '/postabledetail';
    },
    async quickFood_detail() {
      this.$store.commit('quickFoodStatus', 'สั่งด่วน')
      this.$router.push('/quickfoodorder')
    },
    async openMoneyInOut() {
      this.loading_page_money_in_out = true
      this.open_money_in_out = true
      this.money_in_out_name_list = []
      await HTTP.get('/list_delivery', {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
        .then((response) => {
          if (response.data.successful === true) {
            this.money_in_out_name_list = response.data.delivery
          }

        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })

      await HTTP.get('/POS/money-in-outs-list', {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
        .then((response) => {
          if (response.data.successful === true) {
            this.data_money_in_out = response.data.money_list
            this.money_in_out_all = response.data.total_price
            this.loading_page_money_in_out = false
          }

        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
    },
    setMoneyInOutPriceAccept() {
      this.money_in_out_price_accept = this.money_in_out_price
      this.money_in_out_price_accept_all = this.money_in_out_price_accept - this.money_in_out_price
    },
    setMoneyInOutPriceAcceptAll() {
      this.money_in_out_price_accept_all = this.money_in_out_price_accept - this.money_in_out_price
    },
    async addMoneyInOut() {
      if (this.$refs.form_money_in_out.validate()) {
        this.loading_page_money_in_out = true

        HTTP.post('/POS/money-in-outs-create', {
          debtor_id: this.money_in_out_name,
          price: this.money_in_out_price,
          description: this.money_in_out_description,
          status: this.money_in_out_value,
        }, {
          headers: {
            "Authorization": `Bearer ${this.$store.state.token}`
          }
        })
          .then((response) => {
            if (response.data.successful === true) {
              this.money_in_out_name = null
              this.money_in_out_price_accept = null
              this.money_in_out_price = null
              this.money_in_out_price_accept_all = 0
              this.money_in_out_description = null
              this.money_in_out_value = null
              this.alert_money_in_out_notify = true
              setTimeout(() => this.alert_money_in_out_notify = false, 5000)
              this.openMoneyInOut()
            }

          }).catch((error) => {
            if (error.response.status === 401) {
              this.$store.commit('logOutSuccess')
              this.$router.push('/login')
            }
          })
      }
    },
    async openConfirmDeleteMoneyInOut(id) {
      this.alert_money_in_out = true
      this.money_in_out_delete_id = id
      this.remove_money_in_out_description = null
      this.remove_money_in_out_reason_check = false
      this.remove_money_in_out_reason = null
    },
    async removeMoneyInOutDescription() {
      this.remove_money_in_out_reason_check = false
      if (this.remove_money_in_out_description == 'อื่นๆ') {
        this.remove_money_in_out_reason_check = true
      }
    },
    async removeMoney_in_out() {
      if (this.$refs.form_remove_money_in_out.validate()) {
        this.alert_money_in_out = false
        this.loading_page_money_in_out = true
        let cancel_description = this.remove_money_in_out_description
        if (this.remove_money_in_out_reason_check) {
          cancel_description = this.remove_money_in_out_reason
        }
        HTTP.post('/POS/money-in-outs-delete', {
          id: this.money_in_out_delete_id,
          description_delete: cancel_description,
        }, {
          headers: {
            "Authorization": `Bearer ${this.$store.state.token}`
          }
        })
          .then((response) => {
            if (response.data.successful === true) {
              this.money_in_out_delete_id = null
              this.remove_money_in_out_description = null
              this.message_remove_money_in_out = true
              setTimeout(() => this.message_remove_money_in_out = false, 5000)
              this.openMoneyInOut()
            }

          }).catch((error) => {
            if (error.response.status === 401) {
              this.$store.commit('logOutSuccess')
              this.$router.push('/login')
            }
          })

      }
    },
    async openDeliveryAdd() {
      this.open_add_delivery = true
      this.delivery_name = null
      this.delivery_service = null
      this.delivery_vat = null
      this.delivery_color_code = null
    },
    async addDelivery() {
      if (this.$refs.form_delivery_add.validate()) {
        this.open_add_delivery = false
        this.loading_page_money_in_out = true
        const data = {
          debtor_name: this.delivery_name,
          service_charge: this.delivery_service,
          vat: this.delivery_vat,
          color_code: this.delivery_color_code,
        }
        assignrelevantpeopleall.addDebtor(data).then((response) => {
          if (response.data.successful === true) {
            this.openMoneyInOut()
            this.alert_delivery = true
            setTimeout(() => this.alert_delivery = false, 5000)
          }
        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })

        this.delivery_name = null
        this.delivery_service = null
        this.delivery_vat = null
      }
    },
    async detailDelivery(id) {
      this.loading_edit_delivery_page = true
      this.open_edit_delivery = true
      assignrelevantpeopleall.detailDebtor(id).then((response) => {
        if (response.data.successful === true) {
          this.edit_delivery_id = response.data.debtor.id
          this.edit_delivery_name = response.data.debtor.debtor_name
          this.edit_delivery_service = response.data.debtor.service_charge
          this.edit_delivery_vat = response.data.debtor.vat
          this.edit_delivery_color_code = response.data.debtor.color_code
          this.loading_edit_delivery_page = false
        }
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    async editDelivery() {
      if (this.$refs.form_delivery_edit.validate()) {
        this.loading_edit_delivery_page = true
        this.open_edit_delivery = false
        this.loading_page_money_in_out = true

        const data = {
          debtor_name: this.edit_delivery_name,
          service_charge: this.edit_delivery_service,
          vat: this.edit_delivery_vat,
          color_code: this.edit_delivery_color_code,
        }

        assignrelevantpeopleall.editDebtor(this.edit_delivery_id, data).then((response) => {
          if (response.data.successful === true) {
            this.openMoneyInOut()
            this.alert_edit_delivery = true
            setTimeout(() => this.alert_edit_delivery = false, 5000)
          }
        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
        this.edit_delivery_id = null
        this.edit_delivery_name = null
        this.edit_delivery_service = null
        this.edit_delivery_vat = null
        this.edit_delivery_color_code = null
      }
    },
    async openConfirmDeleteDelivery(id, name) {
      this.delete_delivery_id = id
      this.delete_delivery_name = name
      this.open_confirm_delete_delivery = true
    },
    async closeConfirmDeliveryDelete() {
      this.delete_delivery_id = null
      this.delete_delivery_name = null
      this.open_confirm_delete_delivery = false
    },
    async deleteDelivery() {
      this.loading_page_money_in_out = true
      this.open_confirm_delete_delivery = false
      assignrelevantpeopleall.deleteDebtor(this.delete_delivery_id).then((response) => {
        if (response.data.successful === true) {
          this.delete_delivery_id = null
          this.delete_delivery_name = null
          this.openMoneyInOut()
          this.alert_delete_delivery = true
          setTimeout(() => this.alert_delete_delivery = false, 5000)
        }
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    async checkPerTable() {
      this.per_table = []
    },
    limiterPerTable(value) {
      if (value.length > 4) {
        value.pop()
      }
    },
    async countTime() {
      this.data.forEach((detail) => {
        if (detail.status_timer == 1 && detail.bell_status == 0) {
          const [dateComponents, timeComponents] = detail.end_time.split(' ')
          const [year, month, day] = dateComponents.split('-')
          const end_time = `${year}/${month}/${day} ${timeComponents}`
          const countDownToTime = new Date(end_time).getTime()
          const timeNow = new Date().getTime()
          const timeDifference = countDownToTime - timeNow
          const millisecondsInOneSecond = 1000
          const millisecondsInOneMinute = millisecondsInOneSecond * 60
          const millisecondsInOneHour = millisecondsInOneMinute * 60
          const millisecondsInOneDay = millisecondsInOneHour * 24
          const remainderDifferenceInHours = (timeDifference % millisecondsInOneDay) / millisecondsInOneHour
          const remainderDifferenceInMinutes = (timeDifference % millisecondsInOneHour) / millisecondsInOneMinute
          const remainderDifferenceInSeconds = (timeDifference % millisecondsInOneMinute) / millisecondsInOneSecond
          let remainingHours = Math.floor(remainderDifferenceInHours)
          let remainingMinutes = Math.floor(remainderDifferenceInMinutes)
          let remainingSeconds = Math.floor(remainderDifferenceInSeconds)
          if (remainingHours < 10) {
            remainingHours = '0' + remainingHours
          }
          if (remainingMinutes < 10) {
            remainingMinutes = '0' + remainingMinutes
          }
          if (remainingSeconds < 10) {
            remainingSeconds = '0' + remainingSeconds
          }

          detail.count_time = remainingHours + " : " + remainingMinutes + " : " + remainingSeconds
          if (timeDifference < 0) {
            detail.count_time = "00 : 00 : 00"
            if (detail.notification_timeout_buffet == true && !this.notification_table_name && !this.notification_table_type && !this.notification_table_time) {
              detail.notification_timeout_buffet = false

              this.notification_table_name = detail.name
              this.notification_table_type = detail.ragne_name
              this.notification_table_time = detail.buffet_time
              this.notification_table_bell_status = detail.bell_status
              this.notification_table_opentable_id = detail.opentable_id
              this.open_notification_timeout_buffet = true
            }
          }
        }
      })
    },
    async closeNotificationTimeoutBuffet() {
      this.open_notification_timeout_buffet = false
      this.notification_table_name = null
      this.notification_table_type = null
      this.notification_table_time = null
      this.notification_table_bell_status = null
      this.notification_table_opentable_id = null
    },
    async confirmNotificationTimeoutBuffet() {
      this.loading_notification_timeout_buffet = true
      HTTP.post('/POS/table/closeBell/' + this.notification_table_opentable_id, null, {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
        .then((response) => {
          if (response.data.successful === true) {
            this.open_notification_timeout_buffet = false
            this.loading_notification_timeout_buffet = false
            this.notification_table_name = null
            this.notification_table_type = null
            this.notification_table_time = null
            this.notification_table_bell_status = null
            this.notification_table_opentable_id = null
          }

        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
    }
  },
  mounted() {
    this.listData()
    this.queueList()
    this.queueListDetail()
    setInterval(() => { this.countTime() }, 1000)
  }
}
</script>

<style scoped>
.add_delivery_poslist {
  border-bottom: 1px solid;

}

.cursor_delivery_poslist {
  cursor: pointer;
}

.buffet_list_step_three_poslist:hover::before {
  opacity: .08;
}

.colorpicker_poslist {
  width: 25px;
}

.open_table_pos_list {
  padding: 15px;
  background: #ffe1a0;
  border-radius: 20px;
}

.open_per_table_pos_list {
  padding: 15px;
  background: #806554;
  border-radius: 20px;
}

.open_on_table_pos_list {
  padding: 15px;
  background: #6c6c6c;
  border-radius: 20px;
}

.detail_table_list_pos_list {
  display: grid;
  grid-template-columns: 50% 50%;
}

.clock_notification_image {
  width: 30%;
  margin: auto;
}

.clock_notification_image>img {
  max-width: 100%;
}
</style>
